module.exports = "/assets/data/0e9956c1a81293558b8ebbaaebf28bc4-TR27.data.json";